import { UsersQuickQuery } from './quickQuery';

export default UsersQuickQuery;
